import { DrawerBody, DrawerFooter, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { SubmitDeliveryAddressCreateCart, SubmitDeliveryAddressGetCitiesByZipCode, SubmitValidateDeliveryAddress, } from '../../../api/oms/edit-delivery-address';
import { useExperienceContext } from '../../../hooks/useContexts';
import '../../../styles/drawer.scss';
import { getCookieValue } from '../../../utils/cookie-helper';
import { formatPhoneNumber, getWindow } from '../../../utils/general';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { EditDeliveryAddressChangeFormBody } from './EditDeliveryAddressChangeFormBody';
import { EditDeliveryAddressChangeFormFooter } from './EditDeliveryAddressChangeFormFooter';
export var EditDeliveryAddressChangeForm = function (_a) {
    var _b, _c;
    var orderDetailsData = _a.orderDetailsData, fulfillmentGroup = _a.fulfillmentGroup, getCitiesByZipCode = _a.getCitiesByZipCode, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, closeDrawer = _a.closeDrawer, setGetCitiesByZipCode = _a.setGetCitiesByZipCode, setIsChangeForm = _a.setIsChangeForm, setDrawerError = _a.setDrawerError, setIsConfirmation = _a.setIsConfirmation, setUpdatedAddressData = _a.setUpdatedAddressData, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _d = ((_b = fulfillmentGroup.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.deliveryAddress) || {}, name = _d.name, phoneNumbers = _d.phoneNumbers, postalDetails = _d.postalDetails;
    var _e = useState((name === null || name === void 0 ? void 0 : name.firstName) || ''), firstNameValue = _e[0], setFirstName = _e[1];
    var _f = useState((name === null || name === void 0 ? void 0 : name.lastName) || ''), lastNameValue = _f[0], setLastName = _f[1];
    var _g = useState(((phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.dayPhone) && formatPhoneNumber(phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.dayPhone)) || ''), phoneNumberValue = _g[0], setPhoneNumber = _g[1];
    var _h = useState((postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.addressLine1) || ''), streetAddressValue = _h[0], setStreetAddress = _h[1];
    var _j = useState((postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.addressLine2) || null), addressLineTwoValue = _j[0], setAddressLineTwo = _j[1];
    var _k = useState((postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.zipCode) || ''), zipCodeValue = _k[0], setZipCode = _k[1];
    var _l = useState("".concat(postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.city, ", ").concat(postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.state) || ''), cityStateValue = _l[0], setCityState = _l[1];
    var _m = useState(false), invalidField = _m[0], setInvalidField = _m[1];
    var _o = useState({
        value: false,
        et: '',
    }), submitCreateForm = _o[0], setSubmitCreateForm = _o[1];
    var _p = useState({
        firstTry: null,
        valid: null,
    }), isValidated = _p[0], setIsValidated = _p[1];
    var _q = useState(false), isExcludedAddress = _q[0], setIsExcludedAddress = _q[1];
    var _r = useState(false), isLoading = _r[0], setIsLoading = _r[1];
    var isIos = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var traceId = orderDetailsData.traceId;
    useEffect(function () {
        if (submitCreateForm.value) {
            submitEditDeliveryAddress();
        }
    }, [submitCreateForm]);
    useEffect(function () {
        var _a, _b;
        if (getCitiesByZipCode.length > 0) {
            setCityState("".concat((_a = getCitiesByZipCode[0]) === null || _a === void 0 ? void 0 : _a.city, ", ").concat((_b = getCitiesByZipCode[0]) === null || _b === void 0 ? void 0 : _b.stateCode));
        }
    }, [getCitiesByZipCode]);
    useEffect(function () {
        setIsExcludedAddress(false);
    }, [streetAddressValue, zipCodeValue, addressLineTwoValue]);
    var handleClearAllButton = function () {
        setFirstName('');
        setLastName('');
        setPhoneNumber('');
        setStreetAddress('');
        setAddressLineTwo('');
        setZipCode('');
        setCityState('');
    };
    var submitEditDeliveryAddress = function () {
        var _a, _b, _c;
        var requestData = {
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            firstName: firstNameValue,
            lastName: lastNameValue,
            phoneNumber: phoneNumberValue,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            storeId: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentStore) || '',
            lineIds: (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b.map(function (lineItem) { return lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineId; }).filter(function (lineId) { return lineId !== undefined; })) !== null && _c !== void 0 ? _c : [],
            newDeliveryAddress: {
                addressLine1: streetAddressValue,
                addressLine2: addressLineTwoValue,
                city: cityStateValue.split(',')[0],
                state: cityStateValue.split(',')[1].trim(),
                zipCode: zipCodeValue,
                country: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.country) || '',
            },
            forterToken: getCookieValue('forterToken') || '',
            net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
            et: (submitCreateForm === null || submitCreateForm === void 0 ? void 0 : submitCreateForm.et) || '',
        };
        setNewDeliveryAddressDetails({
            firstName: firstNameValue,
            lastName: lastNameValue,
            phoneNumber: phoneNumberValue,
            addressLine1: streetAddressValue,
            addressLine2: addressLineTwoValue,
            city: cityStateValue.split(',')[0],
            state: cityStateValue.split(',')[1].trim(),
            zipCode: zipCodeValue,
            country: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.country) || '',
        });
        SubmitDeliveryAddressCreateCart(requestData, setIsChangeForm, setIsConfirmation, setIsLoading, setDrawerError, setIsExcludedAddress, fulfillmentGroupIndex, closeDrawer, setUpdatedAddressData, traceId);
    };
    var validateDeliveryAddress = function () {
        if (firstNameValue === '' ||
            lastNameValue === '' ||
            phoneNumberValue.length !== 12 ||
            streetAddressValue === '' ||
            zipCodeValue.length !== 5) {
            setInvalidField(true);
            return;
        }
        setIsLoading(true);
        var requestData = {
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            address: {
                addressLine1: streetAddressValue,
                addressLine2: addressLineTwoValue,
                city: cityStateValue.split(',')[0],
                state: cityStateValue.split(',')[1].trim(),
                zipCode: zipCodeValue,
                country: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.country) || '',
            },
        };
        SubmitValidateDeliveryAddress(requestData, isValidated, function (value, et) { return setSubmitCreateForm({ value: value, et: et }); }, setDrawerError, fulfillmentGroupIndex, function (firstTry, valid) {
            return setIsValidated({ firstTry: firstTry, valid: valid });
        }, closeDrawer, setIsLoading, traceId);
    };
    var handleChange = function (event) {
        setCityState(event.target.value);
    };
    var handleZipCodeValueChange = function (zipCodeChange) {
        var request = {
            zipCode: zipCodeChange,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        };
        setGetCitiesByZipCode([]);
        SubmitDeliveryAddressGetCitiesByZipCode(request, setGetCitiesByZipCode, setIsLoading, setIsChangeForm, setDrawerError, fulfillmentGroupIndex, traceId);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-text-right sui-pr-5 sui-pt-4" },
            React.createElement(Link, { component: "button", onClick: function () {
                    handleClearAllButton();
                } }, "Clear All")),
        React.createElement(DrawerBody, null,
            React.createElement(EditDeliveryAddressChangeFormBody, { getCitiesByZipCode: getCitiesByZipCode, firstNameValue: firstNameValue, lastNameValue: lastNameValue, phoneNumberValue: phoneNumberValue, streetAddressValue: streetAddressValue, addressLineTwoValue: addressLineTwoValue, zipCodeValue: zipCodeValue, cityStateValue: cityStateValue, invalidField: invalidField, isExcludedAddress: isExcludedAddress, isValidated: isValidated, setFirstName: setFirstName, setLastName: setLastName, setPhoneNumber: setPhoneNumber, setStreetAddress: setStreetAddress, setAddressLineTwo: setAddressLineTwo, setZipCode: setZipCode, handleZipCodeValueChange: handleZipCodeValueChange, handleChange: handleChange })),
        React.createElement(DrawerFooter, null,
            React.createElement(EditDeliveryAddressChangeFormFooter, { isLoading: isLoading, isIosMobile: isIosMobile, validateDeliveryAddress: validateDeliveryAddress, closeDrawer: closeDrawer }))));
};
